import { HttpClient } from 'api/http-client';
export const OPERATION_TYPE = {
    ADD: 'ADD_PLACEHOLDER',
    REMOVE: 'REMOVE_PLACEHOLDER',
    UPDATE: 'UPDATE_PLACEHOLDER'
};
class TeamsHttpClient extends HttpClient {
    async createTeam(payload) {
        return this.post('/teams', payload);
    }
    async createProjectTeam(payload) {
        return this.post('/teams', payload);
    }
    async updateTeam(teamId, payload) {
        return this.put(`/teams/${teamId}`, payload);
    }
    async deleteTeam(teamId) {
        return this.delete(`/teams/${teamId}`);
    }
    async deleteTeamsByRole(roleId) {
        return this.delete(`/teams/roles/${roleId}`);
    }
    async bulkAssignPlaceholder(payload) {
        return this.put('/teams/bulk-action', payload);
    }
    async bulkPlaceholdersUpdate(payload, projectId) {
        return this.post(`projects/${projectId}/bulk-update-placeholder`, payload);
    }
    async assignPlaceholder(teamId, payload) {
        return this.put(`/teams/${teamId}`, payload);
    }
    async getProjectPlaceholders(projectId) {
        const [, _projectId] = projectId;
        return this.get(`/teams?projectIds=${_projectId}`);
    }
    async getProjectPlaceholdersWithMeta(projectId) {
        const [, _projectId] = projectId;
        return this.get(`/teams?projectIds=${_projectId}&meta=true`);
    }
    async getAllTeamsInAccount() {
        return this.get('/teams?projectIds=all');
    }
    async getTeamsBulkUpdateProgress(projectId) {
        return this.get(`/async/status/projects/${projectId}/active`);
    }
}
export const TeamsAPI = new TeamsHttpClient();
